<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>
<ion-content [fullscreen]="true">
  <ion-grid>
    <app-charging-location
      [isModal]="true"
      (emitCancelSetup)="cancel()"
      (emitLocation)="save($event)"
    ></app-charging-location>
  </ion-grid>
</ion-content>
